/**
 * 숫자에 천 단위 구분자(,)를 추가하는 함수
 * @param {string} value - 변환할 숫자 문자열
 * @returns {string} 천 단위 구분자가 추가된 문자열
 */
export const medicalReceiptFormatNumber = (value) => {
  if (!value || value === '0') return '';
  return Number(value).toLocaleString('ko-KR');
};

/**
 * 날짜 형식을 YYYY-MM-DD 형식으로 변환하는 함수
 * @param {string} value - 변환할 날짜 문자열
 * @returns {string} YYYY-MM-DD 형식의 날짜 문자열
 */
export const medicalReceiptFormatDateByDash = (value) => {
  if (!value) return '';

  // 공백이 있는 경우 첫 번째 부분만 사용
  const dateStr = value.split(' ')[0];

  // YYYYMMDD 형식인 경우
  if (dateStr.length === 8) {
    return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
  }

  return dateStr;
};

/**
 * 날짜 형식을 YYYY-MM-DD 형식으로 변환하는 함수
 * @param {string} value - 변환할 날짜 문자열
 * @returns {string} YYYY.MM.DD 형식의 날짜 문자열
 */
export const medicalReceiptFormatDateByDot = (value) => {
  if (!value) return '';

  // 공백이 있는 경우 첫 번째 부분만 사용
  const dateStr = value.split(' ')[0];

  // YYYYMMDD 형식인 경우
  if (dateStr.length === 8) {
    return `${dateStr.slice(0, 4)}.${dateStr.slice(4, 6)}.${dateStr.slice(6, 8)}`;
  }

  return dateStr;
};

/**
 * 날짜 형식을 연월일을 분리해서 반환하는 함수
 * @param {string} value - 변환할 날짜 문자열
 * @returns {object} 연월일을 분리해서 반환
 */
export const medicalReceiptFormatDateDivided = (value) => {
  if (!value) return '';

  const dateStr = value.split(' ')[0];

  return {
    year: dateStr.slice(0, 4),
    month: dateStr.slice(4, 6),
    day: dateStr.slice(6, 8),
  };
};

/**
 * 날짜 형식을 YYYY-MM-DD HH:MM 형식으로 변환하는 함수
 * input 202510300852
 * @param {string} value - 변환할 날짜 문자열
 * @returns {string} YYYY-MM-DD HH:MM 형식의 날짜 문자열
 */
export const medicalReceiptFormatDateTimeByDash = (value) => {
  if (!value) return '';

  const dateStr = value.slice(0, 8);
  const timeStr = value.slice(8, 12);

  return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)} ${timeStr.slice(0, 2)}:${timeStr.slice(2, 4)}`;
};

/**
 * 날짜 형식을 YYYY-MM-DD HH:MM 형식으로 변환하는 함수
 * input 20251030 08:40:00
 * @param {string} value - 변환할 날짜 문자열
 * @returns {string} YYYY-MM-DD HH:MM 형식의 날짜 문자열
 */
export const medicalReceiptFormatDateTimeByDash2 = (value) => {
  if (!value) return '';

  return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)} ${value.slice(9, 11)}:${value.slice(12, 14)}`;
};

// 202511121147 을 각각 2025, 11, 12 로 분리 추출할수 있도록
/**
 * 날짜 형식을 YYYY-MM-DD HH:MM 형식으로 변환하는 함수
 * @param {string} value - 변환할 날짜 문자열
 * @returns {string} YYYY-MM-DD HH:MM 형식의 날짜 문자열
 */
export const medicalReceiptYearMonthDaySelector = (value) => {
  if (!value) return '';
  return {
    year: value.slice(0, 4),
    month: value.slice(4, 6),
    month2: value.slice(5, 7),
    day: value.slice(6, 8),
    day2: value.slice(8, 10),
    hour: value.slice(8, 10),
    minute: value.slice(10, 12),
  };
};

// export const dateFormatSelector = (value = '', format = 'YYYY-MM-DD') => {
//   if (format === 'YYYY-MM-DD') {
//     return medicalReceiptFormatDateByDash(value);
//   }

//   if (format === 'YYYY.MM.DD') {
//     return medicalReceiptFormatDateByDot(value);
//   }

//   if (format === 'YYYY MM DD') {
//     return medicalReceiptFormatDateDivided(value);
//   }

//   return value;
// };
